export default [
  {
    path: "/rastreio",
    name: "Rastreio",
    component: () => import("../views/rastreio.vue"),
  },
];